export const setUpInfoBadgeToggle = (): void => {
  const toggleButton = document.querySelector(
    '.js-info-badge-toggle',
  ) as HTMLButtonElement;
  const collapsibles = document.querySelectorAll<HTMLElement>(
    '.js-info-badge-collapsible',
  );

  if (!toggleButton || !collapsibles.length) return;

  const handleToggle = () => {
    const isExpanded = toggleButton.getAttribute('aria-expanded') === 'true';
    const newExpandedState = !isExpanded;

    toggleButton.setAttribute('aria-expanded', String(newExpandedState));
    collapsibles.forEach((el) => {
      el.setAttribute('aria-hidden', String(!newExpandedState));
      el.classList.toggle('expanded', newExpandedState);
    });
  };

  toggleButton.addEventListener('click', handleToggle);
};
